import { render, staticRenderFns } from "./ZZYOne.vue?vue&type=template&id=79135f99&scoped=true&"
import script from "./ZZYOne.vue?vue&type=script&lang=js&"
export * from "./ZZYOne.vue?vue&type=script&lang=js&"
import style0 from "./ZZYOne.vue?vue&type=style&index=0&id=79135f99&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79135f99",
  null
  
)

export default component.exports